<template>
    <div>
        <card-header icon="fa-user-tie">
            <template #title>
                <span class="is-clickable" @click="$copyText(reseller.first_name + ' ' + reseller.last_name)">
                    {{ reseller.first_name }} {{ reseller.last_name }}
                </span>
            </template>
        </card-header>

        <card-toolbar v-if="currentUser.isSuper">
            <b-tooltip label="Edit User">
                <button class="icon-only" @click="$openCard('edit-org-user', {userId: reseller.id}, card)"><i class="fal fa-pencil"></i></button>
            </b-tooltip>
            <b-tooltip label="Portal Login" v-if="currentUser.id !== reseller.id">
                <button class="icon-only" @click="switchAndRedirect(reseller.id)"><i class="far fa-circle-user"></i></button>
            </b-tooltip>
        </card-toolbar>

        <card-body>
            <data-row title="Name">{{ reseller.first_name }} {{ reseller.last_name }}</data-row>
            <data-row title="Username">{{ reseller.username }}</data-row>
            <data-row title="Created">{{ reseller.created_at | moment('MMM Do, YYYY h:mm A') }}</data-row>
            <data-row title="Last Login">{{ reseller.last_login_at | moment('MMM Do, YYYY h:mm A') }}</data-row>
            <card-list v-if="currentUser.isSuper">
                <separator-list-item />
                <navigation-list-item
                    title="Enrollment Report"
                    icon="fa-clipboard-check"
                    @click="$openCard('reseller-enroll-report', {userId: reseller.id}, card)"
                    :active="isActive('reseller-enroll-report')"
                />
                <navigation-list-item
                    title="Reseller Activity"
                    icon="fa-chart-line"
                    @click="$openCard('reseller-activity', {resellerId: reseller.id}, card)"
                    :active="isActive('reseller-activity')"
                />
            </card-list>
        </card-body>

        <card-footer class="has-text-right">
            <span class="is-clickable" @click="$copyText(reseller.id)"><i class="fal fa-barcode-alt mr-2"></i>{{ reseller.id }}</span>
        </card-footer>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import DataRow from "../../TIER/components/DataRow.vue";

    import {client as http} from '@/http_client';

    export default {
        components: {DataRow, SeparatorListItem, NavigationListItem, CardFooter, CardToolbar, CardList, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                reseller: {}
            };
        },
        computed: {
            ...mapGetters(['currentUser']),
        },
        methods: {
            ...mapActions(['switchUser']),
            switchAndRedirect: function(resellerId) {
                if (!this.currentUser.isSuper) return;
                this.switchUser({ portal_id: resellerId }).then(() => {
                    this.$resetCards();
                });
            },
            loadReseller: function(force) {
                this.$emit('loading', true);
                http.get('resellers/' + this.props.resellerId, {force}).then(response => {
                    this.reseller = response.data;
                    this.$emit('title', this.reseller.first_name + ' ' + this.reseller.last_name);
                    this.$emit('loading', false);
                });
            },
            isActive: function(component) {
                return (this.child && this.child.definition && this.child.definition.component === component);
            }
        },
        watch: {
            'props.resellerId': function() {
                this.loadReseller();
            }
        },
        mounted: function() {
            this.loadReseller();
        }
    };
</script>
